export const environment = {
  production: false,
  apiUrl: 'https://api.dev.apex.macawshub.com/api'
};
